var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElevator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 18.0312H15.625C13.0362 18.0312 10.9375 20.1719 10.9375 22.8125V41.9375C10.9375 44.5781 13.0362 46.7188 15.625 46.7188H34.375C36.9638 46.7188 39.0625 44.5781 39.0625 41.9375V22.8125C39.0625 20.1719 36.9638 18.0312 34.375 18.0312H31.25M31.25 11.6563L25 5.28125M25 5.28125L18.75 11.6562M25 5.28125L25 32.375",
    stroke: "#90CC61",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElevator);
export default __webpack_public_path__ + "static/media/elevator.5af2c10456f41ec95f7d3a49d3017f16.svg";
export { ForwardRef as ReactComponent };